import { GMTInfo, Page } from '@/models/common';
import { useRequestImmer } from '../api/hooks';

export const FootprintEndpoint = `/footprint`;

// const footprintTypes = {
//   1: '访问小程序',
//   2: '商品详情页',
//   3: '分类页',
//   4: '首页',
//   5: '套餐卡',
//   6000: '预约页',
//   1000: '营销活动页',
//   1001: '营销活动验证',
// };

// export const getFootprintTypeLabel = (type: keyof typeof footprintTypes) => {
//   return footprintTypes[type] || 'UNK';
// };

export interface FootprintVO extends GMTInfo {
  type: number;
  typeStr?: string;
  typeIdStr?: string;
  wxScene?: string;
}

// export interface Footprint extends GMTInfo {
//   type: keyof typeof footprintTypes;
//   typeId?: string;
//   wsScene?: string;
// }

export const requestUserFootprintList = () =>
  useRequestImmer<{ list: FootprintVO[]; page: Page }>(
    {
      url: `${FootprintEndpoint}/{username}`,
      method: 'get',
    },
    {
      manual: true,
    }
  );
